import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeContextProvider } from './contexts/ThemeContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import ClienteForm from './pages/ClienteForm';
import ClienteList from './pages/ClienteList';
import Processos from './pages/Processos';
import ProcessoForm from './pages/ProcessoForm';
import ProcessoView from './pages/ProcessoView';
import AndamentoForm from './pages/AndamentoForm';
import Advogados from './pages/Advogados';
import AdvogadoForm from './pages/AdvogadoForm';
import BkpDuplicados from './pages/BkpDuplicados';
import StatusLista from './pages/StatusLista';
import TipoBeneficioLista from './pages/TipoBeneficioLista';
import LocalizacaoLista from './pages/LocalizacaoLista';
import VaraLista from './pages/VaraLista';
import TipoAndamentoLista from './pages/TipoAndamentoLista';
import TipoAcaoLista from './pages/TipoAcaoLista';
import ParteExterna from './pages/ParteExterna';
import ConsultaCliente from './pages/ConsultaCliente';
import Auditoria from './pages/Auditoria';
import Aniversariantes from './pages/Aniversariantes';
import Usuarios from './pages/Usuarios';
import Prazos from './pages/Prazos';
import PrazoForm from './pages/PrazoForm';
import CalendarioPrazos from './pages/CalendarioPrazos';
import FluxoCaixa from './pages/FluxoCaixa';
import HistoricoAcesso from './pages/HistoricoAcesso';
import AndamentosAPIConfig from './pages/AndamentosAPIConfig';
import Backup from './pages/Backup';
import Bloqueio from './pages/Bloqueio';
import ConfiguracaoUsuario from './pages/ConfiguracaoUsuario';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeContextProvider>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/bloqueio" element={<Bloqueio />} />
          <Route path="/consulta" element={<ConsultaCliente />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/clientes" element={
            <ProtectedRoute>
              <Layout>
                <Clientes />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/clientes/novo" element={
            <ProtectedRoute>
              <Layout>
                <ClienteForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/clientes/editar/:id" element={
            <ProtectedRoute>
              <Layout>
                <ClienteForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/clientes/lista" element={
            <ProtectedRoute>
              <Layout>
                <ClienteList />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/processos" element={
            <ProtectedRoute>
              <Layout>
                <Processos />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/processos/novo" element={
            <ProtectedRoute>
              <Layout>
                <ProcessoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/processos/editar/:id" element={
            <ProtectedRoute>
              <Layout>
                <ProcessoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/processos/ver/:id" element={
            <ProtectedRoute>
              <Layout>
                <ProcessoView />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/processos/:processoId/andamentos" element={
            <ProtectedRoute>
              <Layout>
                <AndamentoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/advogados" element={
            <ProtectedRoute>
              <Layout>
                <Advogados />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/advogados/novo" element={
            <ProtectedRoute>
              <Layout>
                <AdvogadoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/advogados/editar/:id" element={
            <ProtectedRoute>
              <Layout>
                <AdvogadoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/bkp-duplicados" element={
            <ProtectedRoute>
              <Layout>
                <BkpDuplicados />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/status" element={
            <ProtectedRoute>
              <Layout>
                <StatusLista />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/tipo-beneficio" element={
            <ProtectedRoute>
              <Layout>
                <TipoBeneficioLista />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/localizacao" element={
            <ProtectedRoute>
              <Layout>
                <LocalizacaoLista />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/vara" element={
            <ProtectedRoute>
              <Layout>
                <VaraLista />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/tipo-andamento" element={
            <ProtectedRoute>
              <Layout>
                <TipoAndamentoLista />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/tipo-acao" element={
            <ProtectedRoute>
              <Layout>
                <TipoAcaoLista />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/parte-externa" element={
            <ProtectedRoute>
              <Layout>
                <ParteExterna />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/auditoria" element={
            <ProtectedRoute>
              <Layout>
                <Auditoria />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/usuarios" element={
            <ProtectedRoute>
              <Layout>
                <Usuarios />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/aniversariantes" element={
            <ProtectedRoute>
              <Layout>
                <Aniversariantes />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/prazos" element={
            <ProtectedRoute>
              <Layout>
                <Prazos />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/prazos/calendario" element={
            <ProtectedRoute>
              <Layout>
                <CalendarioPrazos />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/prazos/novo" element={
            <ProtectedRoute>
              <Layout>
                <PrazoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/prazos/editar/:id" element={
            <ProtectedRoute>
              <Layout>
                <PrazoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/fluxo-caixa" element={
            <ProtectedRoute>
              <Layout>
                <FluxoCaixa />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/historico-acesso" element={
            <ProtectedRoute>
              <Layout>
                <HistoricoAcesso />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/api-andamentos" element={
            <ProtectedRoute>
              <Layout>
                <AndamentosAPIConfig />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/backup" element={
            <ProtectedRoute>
              <Layout>
                <Backup />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracao-usuario" element={
            <ProtectedRoute>
              <Layout>
                <ConfiguracaoUsuario />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/configuracao-usuario/:id" element={
            <ProtectedRoute>
              <Layout>
                <ConfiguracaoUsuario />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeContextProvider>
  );
}

export default App; 